
import SecurityUser from "../../../assets/duotone/SecurityUser.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SecurityUserIcon({ className, dataTestid = "SecurityUserIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SecurityUser data-testid={dataTestid} className={classes} {...rest} />
  );
}
